import { render, staticRenderFns } from "./SidebarView.vue?vue&type=template&id=d2290410"
import script from "./SidebarView.vue?vue&type=script&lang=js"
export * from "./SidebarView.vue?vue&type=script&lang=js"
import style0 from "./SidebarView.vue?vue&type=style&index=0&id=d2290410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports